import { OPEN_DIALOG, CLOSE_DIALOG } from "./types";

const dialogReducer = (stateDialog : any, action: any) => {
  const { type, payload} = action;
  switch (type) {
    case OPEN_DIALOG:
      return {
        open: payload.open,
        title: payload.title,
        text: payload.text,
        handleAgree: payload.handleAgree
      };
    case CLOSE_DIALOG:
      return {
        ...stateDialog,
        open: payload.open,
      };

    default:
      return stateDialog;
  }
};

export default dialogReducer;